import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import DestinationsSection from './components/DestinationsSection';
import WhyChooseSection from './components/WhyChooseSection';
import TestimonialsSection from './components/TestimonialsSection';
import DevisSection from './components/DevisSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://atlastransportlogistic.fr';

  useEffect(() => {
    const schemaLocalBusiness = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": `${siteUrl}/#organization`,
      "name": "ATLAS Transport & Logistics",
      "image": "https://static.readdy.ai/image/cbcf5606af0bc95b5fc9ad6ccd55420d/76effcac3bdb84a849ec64c23a95abb9.png",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Nanterre",
        "addressLocality": "Nanterre",
        "addressRegion": "Île-de-France",
        "postalCode": "92000",
        "addressCountry": "FR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "48.8905",
        "longitude": "2.2069"
      },
      "url": siteUrl,
      "telephone": "+33-1-XX-XX-XX-XX",
      "priceRange": "$$",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "08:00",
          "closes": "18:00"
        }
      ],
      "description": "ATLAS Transport & Logistics à Nanterre propose transport aérien maritime vers Afrique, groupage marchandises, fret international, logistique import export, stockage entreposage, dédouanement.",
      "areaServed": {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "48.8905",
          "longitude": "2.2069"
        },
        "geoRadius": "50000"
      }
    };

    const schemaWebSite = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      "url": siteUrl,
      "name": "ATLAS Transport & Logistics",
      "description": "Spécialiste du transport aérien et maritime vers l'Afrique",
      "publisher": { "@id": `${siteUrl}/#organization` },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };

    const schemaBreadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Accueil", "item": siteUrl }
      ]
    };

    const schemas = [schemaLocalBusiness, schemaWebSite, schemaBreadcrumb];
    const scriptIds = ['ld-local-business', 'ld-website', 'ld-breadcrumb-home'];

    schemas.forEach((schema, i) => {
      let script = document.getElementById(scriptIds[i]) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = scriptIds[i];
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });

    return () => {
      scriptIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [siteUrl]);

  return (
    <div className="min-h-screen">
      <HeroSection />
      <ServicesSection />
      <DestinationsSection />
      <WhyChooseSection />
      <TestimonialsSection />
      <DevisSection />
      <ContactSection />
    </div>
  );
}
